'use client';
import { Children, cloneElement } from 'react';

/**
 * Возвращает массив с разделителем в виде React-элемента, вставленным
 * между каждой парой соседних элементов исходного массива.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ var joinChildren = function(children, separator) {
    var childrenArray = Children.toArray(children).filter(Boolean);
    return childrenArray.reduce(function(output, child, index) {
        output.push(child);
        if (index < childrenArray.length - 1) {
            output.push(/*#__PURE__*/ cloneElement(separator, {
                key: "separator-" + index
            }));
        }
        return output;
    }, []);
};

export { joinChildren };
